import { ChakraProvider } from "@chakra-ui/react";
import React, { useReducer } from "react";

import { lightTheme } from "../themes/lightTheme";
import { themeConfigurationReducer } from "../configuration/themeConfigurationReducer";
import { ConfigurationThemeProvider } from "./ConfigurationThemeProvider";

import { IChildrenProp } from "types/IChildrenProp";

interface IProps extends IChildrenProp {}

const ChakraThemeProvider = ({ children }: IProps) => {
  const [state, dispatch] = useReducer(themeConfigurationReducer, {
    theme: lightTheme,
  });

  return (
    <ChakraProvider theme={state.theme}>
      <ConfigurationThemeProvider data={{ theme: state.theme, dispatch }}>
        {children}
      </ConfigurationThemeProvider>
    </ChakraProvider>
  );
};

export { ChakraThemeProvider };
